<template>
  <div class="home-transition1">
    <div class="transition-image-containter"/>
  </div>
</template>

<script>
export default {
  name: 'HomeTransition1',
  props: {
    msg: String
  }
}
</script>

<style scoped lang="scss">
.home-transition1 {
  .transition-image-containter {
    margin: -250px 0px;
    height: 736px;
    background: url("~@/assets/images/Home_Transition1_Asset_SVG.svg") no-repeat center center;
    background-size: cover;
  }
}
</style>
